import React, { useState } from "react";
import ImageSlider from "./ImageSlider";

const beforeAfterSlides = [
  {
    title: "Air Jordan 11 Space Jam\nAfter 3 Icing Sessions",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1760042899/IMG_4824_apex7w.jpg",
  },
  {
    title: "Air Jordan 11 Space Jam\nBefore Icing",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1760042997/IMG_4821_fsoug4.jpg",
  },
  {
    title: "Air Jordan 11 Concord\nAfter 3 Icing Sessions",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1759847541/IMG_4585_cyyetu_0615a2.jpg",
  },
  {
    title: "Air Jordan 11 Concord\nBefore Icing",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1758229324/IMG_4586_ydwynj.jpg",
  },
  {
    title: "Air Jordan 5 Alternative Grape\nAfter 3 Icing Sessions",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1759852770/dup_grape_l2jc8g.png",
  },
  {
    title: "Air Jordan 5 Alternative Grape\nBefore Icing",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1758229323/IMG_4606_ss7ngo.jpg",
  },
  {
    title: "Air Jordan 11 Space Jam\nAfter 3 Icing Sessions",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1760042613/IMG_4829_slsikv_005840.jpg",
  },
  {
    title: "Air Jordan 11 Space Jam\nBefore Icing",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1760042822/IMG_4826_i0x8k9.jpg",
  },
  {
    title: "Air Jordan 5 Black Grape\nAfter 2 Icing Sessions",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1759853037/IMG_4616_wqi2y7.png",
  },
  {
    title: "Air Jordan 5 Black Grape\nBefore Icing",
    url: "https://res.cloudinary.com/djzs24zio/image/upload/v1758229322/IMG_4615_oqzrxm.jpg",
  },
];

const IcingService = ({ services, handleProductClick }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className={modalOpen ? "hidden" : ""}>
      <div className="text-center p-8 bg-white rounded-3xl shadow-xl">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-center text-gray-900 mb-4 leading-tight">
          Re-Ice Your Soles
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          Revitalize your classic sneakers and bring back their original
          crystal-clear look. Our expert "re-icing" service restores yellowed
          and oxidized translucent soles on iconic shoes like Air Jordans and
          Foamposites, making them look brand new again.
        </p>
        <ImageSlider
          slides={beforeAfterSlides}
          onModalStateChange={setModalOpen}
        />
        <div className="flex justify-center w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 my-4 w-full max-w-6xl">
            {services &&
              services
                .filter((service) => service.stock > 0)
                .map((service) => (
                  <div
                    key={service.id}
                    className="product-card cursor-pointer transition duration-200 bg-white flex flex-col rounded-2xl overflow-hidden w-full h-[220px] border-4 border-gray-100 hover:border-indigo-600"
                    onClick={() => handleProductClick(service)}
                  >
                    <div className="px-4 py-6 flex-1 flex flex-col justify-between">
                      <h3 className="text-xl font-extrabold text-gray-900 mb-2">
                        {service.title}
                      </h3>
                      <p className="text-base text-gray-700 mb-4">
                        {service.description}
                      </p>
                      <div className="flex justify-end">
                        <span className="text-xl font-bold text-indigo-600">
                          ${(service.price / 100).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        </div>
        <p className="text-gray-600 mb-8">
          This specialized process removes years of discoloration caused by
          sunlight and oxidation, ensuring your prized possessions are ready to
          be worn or displayed.{" "}
          <a
            href="/contact"
            className="text-indigo-600 underline hover:text-indigo-800 transition"
          >
            Contact us
          </a>{" "}
          today for a free consultation!
        </p>
      </div>
    </div>
  );
};

export default IcingService;
